// Import dependencies
import GLightbox from 'glightbox';
import { initialiser } from '../../ramen-imports/utilitybelt';

const defaultSettings = {
  boxShadowSizeMedium: 10,
  boxShadowSizeSmall: 25,
};

class TwoImages {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.container = el;
    this.imagesContainer = el.querySelector(settings.imageContainer);
    this.firstImage = el.querySelector(settings.firstImage);
    this.firstImageContainer = el.querySelector(settings.firstImageContainer);
    this.mediaQuery = `(min-width: ${settings.breakpoint})`;

    // Set settings
    this.settings = { ...settings, ...defaultSettings };
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    // Call bind events
    this.setImagesContainerHeight();
    this.initGLightbox();

    window.addEventListener('resize', this.setImagesContainerHeight);
  };

  setImagesContainerHeight = () => {
    const firstImageContainerHeight = this.firstImageContainer.offsetHeight;
    const firstImageOffsetTop = this.firstImage.offsetTop;

    // Set parent container height based on first image height + image top offset
    if (window.matchMedia(this.mediaQuery).matches) {
      this.imagesContainer.style.height = `${
        firstImageContainerHeight + firstImageOffsetTop + this.settings.boxShadowSizeMedium
      }px`;
    } else {
      this.imagesContainer.style.height = `${
        firstImageContainerHeight + firstImageOffsetTop + this.settings.boxShadowSizeSmall
      }px`;
    }
  };

  initGLightbox = () => {
    // select slides inside current container
    const slides = this.container.querySelectorAll('figure');

    // prepare elements array for gallery instantiation
    const elements = slides.length > 0 && Array.from(slides).map((slide) => ({
      href: slide.querySelector('img').dataset.src,
      type: 'image',
      title: slide.querySelector('img').alt || null,
    }));

    if (elements.length > 0) {
      // instantiate gallery
      const gallery = elements && GLightbox({
        elements,
        loop: true,
      });

      // open gallery on slide click
      slides.forEach((slide, i) => slide
        .querySelector('.c-image__background')
        .addEventListener('click', () => {
          gallery.openAt(i);
        }));
    }
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, TwoImages);
